import { faLaptopMedical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { Col, Container, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { actions } from '../../../context';
import NewPims from './NewPims';
import Pims from './Pims';
import { Facebook } from 'react-spinners-css';
import NewButton from '../Shared/NewButton';
import Split from '../../Shared/Split';

const Pimses = () => {
    const loc = useLocation();
    const dispatch = useDispatch();
    const [pims, setPims] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addingPims, setAddingPims] = useState(false);

    const toggleAddingPims = useCallback(() => setAddingPims(!addingPims), [addingPims]);

    const refresh = useCallback(async () =>
        dispatch(actions.pims.getAllPims()).then((res) =>
            setPims(res?.data || [])
        ), [dispatch]);

    useEffect(() => {
        setLoading(true);
        refresh().then(() => setLoading(false));
        // eslint-disable-next-line
    }, [dispatch]);

    return (
        <>
            <NewPims
                isOpen={addingPims}
                toggle={toggleAddingPims}
                refresh={refresh}
            />
            <Container style={{ maxHeight: '88vh', overflowY: 'hidden' }}>
                <Row className="text-white">
                    <Col lg="3">
                        <Split>
                            <h2>
                                <FontAwesomeIcon icon={faLaptopMedical} />
                                &emsp;Pims
                            </h2>
                            <div>
                                <NewButton
                                    noSpaces
                                    id="newPims"
                                    title="Create new pims"
                                    onClick={toggleAddingPims}
                                />
                            </div>
                        </Split>
                        <ListGroup
                            style={{ maxHeight: '80vh', overflowY: 'scroll' }}>
                            {loading ? (
                                <div className="mx-auto">
                                    <Facebook color="eee" />
                                </div>
                            ) : (
                                <>
                                    {pims.map((pms, x) => (
                                        <Link
                                            key={pms.id}
                                            to={'/admin/pims/' + pms.id}
                                            style={{ textDecoration: 'none' }}>
                                            <ListGroupItem
                                                action
                                                active={loc.pathname.includes(
                                                    pms.id
                                                )}>
                                                {pms.name}
                                            </ListGroupItem>
                                        </Link>
                                    ))}
                                </>
                            )}
                        </ListGroup>
                    </Col>
                    <Col lg="9">
                        <Switch>
                            <Route
                                path="/admin/pims/:pimsId"
                                component={Pims}
                            />
                        </Switch>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Pimses;
